import React, { useRef, useState, forwardRef } from "react";
import { IconButton, makeStyles, TableCell, TableRow } from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp, MoreVert } from "@material-ui/icons";
import { SubVersionRowMenu } from "./SubVersionRowMenu";
import { listItem } from "@contracts/CustomerContractProfile/components/SubVersionsTable/SubVersionTableStore";

type Props = {
  data: listItem;
  onDuplicate: () => void;
  onEdit: () => void;
  onDelete: () => void;
  disabled: boolean;
  open?: boolean;
  onCollapse?: () => void;
};

export const SubVersionRow = forwardRef<Record<string, never>, Props>((props, ref) => {
  const { data } = props;
  const classes = useStyles({});
  const rowRef = useRef(null);
  const menuRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const runMenuAction = (action: () => void) => {
    action();
    setMenuOpen(false);
  };

  return (
    <TableRow ref={rowRef} className={classes.row}>
      <TableCell component="th" scope="row">
        {props.onCollapse && (
          <IconButton aria-label="expand row" size="small" onClick={props.onCollapse}>
            {props.open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        )}
      </TableCell>

      <TableCell>{data.name}</TableCell>

      <TableCell>
        <div className={classes.actions}>
          <IconButton
            key={`menu-${data._id}`}
            ref={menuRef}
            aria-controls="menu"
            aria-haspopup="true"
            size="small"
            onClick={() => setMenuOpen(true)}
            disabled={props.disabled}
          >
            <MoreVert />
          </IconButton>

          <SubVersionRowMenu
            open={menuOpen}
            anchor={menuRef.current}
            onClose={() => setMenuOpen(false)}
            onEdit={() => runMenuAction(props.onEdit)}
            onDuplicate={() => runMenuAction(props.onDuplicate)}
            onDelete={() => runMenuAction(props.onDelete)}
          />
        </div>
      </TableCell>
    </TableRow>
  );
});

const useStyles = makeStyles(() => ({
  iconWrap: {
    display: "flex",
    alignItems: "center",
    "& svg": {
      marginLeft: 5
    }
  },
  link: {
    display: "inherit"
  },
  actions: {
    minWidth: "90px",
    textAlign: "right"
  },
  dates: {
    maxHeight: 75,
    whiteSpace: "nowrap",
    overflow: "hidden"
  },
  row: {
    "&:last-child > td, &:last-child th": {
      borderBottom: "none"
    }
  }
}));
